import { resolveSchemaTreeFromForm } from '@root/helpers/schema/resolveSchemaTreeFromForm';
import schemaCdr from '@root/helpers/schema/schema-cdr.json';
import type { SchemaTreeToFlatListResult } from '@root/helpers/schema/schemaTreeToFlatList';
import { schemaTreeToFlatList } from '@root/helpers/schema/schemaTreeToFlatList';
import type { JSONSchema, ResolvedSchemaTree } from '@root/helpers/schema/types';

export interface CdrSchema {
  tree: ResolvedSchemaTree[];
  flatList: SchemaTreeToFlatListResult[];
  definitions: typeof schemaCdr.definitions;
}

const rawTree = resolveSchemaTreeFromForm(schemaCdr as unknown as JSONSchema, {}, true);
// Unwrap the top-level "CDR Form" wrapper so the accordion starts at Risk Details, Security Details, etc.
const tree: ResolvedSchemaTree[] =
  rawTree.length === 1 && rawTree[0].title === 'CDR Form' ? (rawTree[0].children as ResolvedSchemaTree[]) : rawTree;
const flatList = schemaTreeToFlatList(tree);

export const CDR_SCHEMA: CdrSchema = { tree, flatList, definitions: schemaCdr.definitions };
